module.exports = __webpack_public_path__ + "static/media/Inspections.c3efb4c8.png";